import {PIXI} from '@colonist/pixi'
import {CardDataController} from '@colonist/game-card-types'
import {UIGameConstants} from '../UIGameConstants'
import {CardCountView} from '../../ui_canvas_engine/CardCountView'
import {UIGameManager} from '../UIGameManager'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {UIGamePlayerInformationView} from './UIGamePlayerInformationView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {CardValidatorOrdered} from '@colonist/game-mechanic-validators'
import {CardEnum} from '@colonist/game-states'

export class UIGamePlayerInformationProgressCardView implements UIGameMechanic {
    private readonly cardCountViews: CardCountView[] = []
    private readonly playerInformation: UIGamePlayerInformationView

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, container: PIXI.Container, progressCards: CardEnum[], hideCards: boolean, textColor: string, playerInformation?: UIGamePlayerInformationView) {
        const cardsToDisplay: CardEnum[] = [CardEnum.ProgressCardTradeBack, CardEnum.ProgressCardPoliticsBack, CardEnum.ProgressCardScienceBack]
        const cardY = y
        const cardW = h * UIGameConstants.CARD_RATIO
        const cardSpacing = w / (cardsToDisplay.length + 1)
        let cardX = cardSpacing - cardW / 2

        const isTradeView = false
        const progressCardsValidator = new CardValidatorOrdered({cards: progressCards})

        for(const progressCard of cardsToDisplay) {
            const cardCountView = new CardCountView(uiGameManager, cardX, cardY, cardW, h, container, progressCard, textColor, isTradeView, hideCards)
            const cardCount = progressCardsValidator.getCardCountForCard(progressCard)
            cardCountView.update(cardCount)
            cardCountView.repositionStackX()
            cardX += cardSpacing
            this.cardCountViews.push(cardCountView)
        }
        if(!playerInformation) return
        this.playerInformation = playerInformation
        this.updatePlayerProgressCardCount()
        uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.PlayerControllerStateUpdated: this.updatePlayerProgressCardCount(); break
            default: break
        }
    }

    private updatePlayerProgressCardCount() {
        const progressCards = this.playerInformation.progressCardsPlayerValidator?.progressCards
        if(progressCards == undefined) return

        const progressCardEnums = progressCards.cards.map((card: CardEnum) => CardDataController.getCardDataForCard(card)?.cardTypeEnum)
        for(const cardCountView of this.cardCountViews) {
            const cardEnum = cardCountView.cardEnum
            const cardTypeEnum = CardDataController.getCardDataForCard(cardEnum)?.cardTypeEnum
            const cardCount = ArrayUtils.countOccurenceOfValueInArray(progressCardEnums, cardTypeEnum)
            cardCountView.update(cardCount)
        }
    }
}
